import React from 'react';
import { Button, Flex, useSnackbar } from 'pounceV2';
import { extractErrorMessage } from 'Helpers/utils';
import dayjs from 'dayjs';
import { useUpdateUserNotifications } from './graphql/UpdateUserNotifications.generated';

const NotificationsActionsV3 = ({
  disableMarkAsRead,
  disableMarkAsUnread,
  disableArchive,
  disableUnArchive,
  tab = 'inbox',
}: {
  disableMarkAsRead?: boolean;
  disableMarkAsUnread?: boolean;
  disableArchive?: boolean;
  disableUnArchive?: boolean;
  tab?: 'inbox' | 'archived';
}) => {
  const { pushSnackbar } = useSnackbar();
  const [updateNotifications] = useUpdateUserNotifications({
    update: (cache, { data: { updateUserNotifications } }) => {
      updateUserNotifications.notifications.forEach(notification => {
        const notificationId = cache.identify({
          id: notification.id,
          __typename: 'Notification',
        });
        cache.modify({
          id: notificationId,
          fields: {
            readAt: () => notification.readAt,
            archivedAt: () => notification.archivedAt,
          },
        });
      });
    },
    onError: error => {
      pushSnackbar({
        variant: 'error',
        title: extractErrorMessage(error),
      });
    },
  });

  const now = dayjs().utc().toISOString();

  return tab === 'inbox' ? (
    <Flex justify="space-between" align="center" gap={3} p={6}>
      <Button
        fullWidth
        variant="outline"
        size="small"
        onClick={() => {
          updateNotifications({
            variables: {
              input: {
                readAt: now,
              },
            },
          });
        }}
        disabled={disableMarkAsRead}
      >
        Mark all as Read
      </Button>

      <Button
        fullWidth
        variant="outline"
        size="small"
        onClick={() => {
          updateNotifications({
            variables: {
              input: {
                readAt: '0001-01-01T00:00:00Z',
              },
            },
          });
        }}
        disabled={disableMarkAsUnread}
      >
        Mark all as Unread
      </Button>

      <Button
        fullWidth
        variant="outline"
        size="small"
        onClick={() => {
          updateNotifications({
            variables: {
              input: {
                archivedAt: now,
              },
            },
          });
        }}
        disabled={disableArchive}
      >
        Archive All
      </Button>
    </Flex>
  ) : (
    <Flex justify="space-between" align="center" p={6}>
      <Button
        fullWidth
        variant="outline"
        size="small"
        onClick={() => {
          updateNotifications({
            variables: {
              input: {
                archivedAt: '0001-01-01T00:00:00Z',
              },
            },
          });
        }}
        disabled={disableUnArchive}
      >
        Unarchive All
      </Button>
    </Flex>
  );
};

export default NotificationsActionsV3;
